<template>
  <div>
    <page-main
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      :disabled="disabled"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @openEditFormDialog="openEditFormDialog"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <ChooseOrderGoodsFabricDialog
      :visible.sync="sampleMaterialDialogOptions.visible"
      :title="'添加订单面料'"
      :orderCode="orderCode"
      type="checkbox"
      @confirm="confirm"
    />
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import ChooseOrderGoodsFabricDialog from '@/views/factory/components/choose-order-demand-fabric/dialog.vue'

export default {
  components: {
    PageMain,
    PageHeader,
    ChooseOrderGoodsFabricDialog,
  },
  mixins: [BaseTable, EditLoading],
  props: {
    techCuttingCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      usePage: true,
      sampleMaterialDialogOptions: {
        disabled: false,
        visible: false,
        title: '',
        form: {},
      },
    }
  },
  computed: {},
  watch: {
    techCuttingCode: {
      handler(val) {
        if (val) this.getData()
      },
      immediate: true,
    },
  },
  activated() {},
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .techCuttingInfoDetailListApi({
          ...form,
          ...this.page,
          techCuttingCode: this.techCuttingCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, form = {} }) {
      const types = {
        add: '添加面料信息',
        edit: '编辑面料信息',
      }
      this.sampleMaterialDialogOptions = {
        visible: true,
        disabled: type === 'edit',
        title: types[type],
        form,
      }
    },
    confirm(parms) {
      this.loadingOpen()
      this.$api
        .techCuttingInfoDetailAddApi({
          listFabric: parms,
          techCuttingCode: this.techCuttingCode,
          orderCode: this.orderCode,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.getData()
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>
